import { api } from "../../api/apiSlice";

// Per-user pinned pages ("+" button next to the Feedback widget). Every
// endpoint here is self-service - the API scopes reads/writes to the
// caller's own token, there's no branch/permission filtering to pass.
export const quickMenuApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listQuickMenuItems: builder.query({
      query: () => ({ url: "/quickmenu/items" }),
      providesTags: [{ type: "QuickMenu", id: "LIST" }],
    }),
    pinPage: builder.mutation({
      query: (body) => ({ url: "/quickmenu/items", method: "POST", data: body }),
      invalidatesTags: [{ type: "QuickMenu", id: "LIST" }],
    }),
    unpinPage: builder.mutation({
      query: (quickMenuItemId) => ({ url: `/quickmenu/items/${quickMenuItemId}`, method: "DELETE" }),
      invalidatesTags: [{ type: "QuickMenu", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const { useListQuickMenuItemsQuery, usePinPageMutation, useUnpinPageMutation } = quickMenuApi;
